/**
 * Shared app login (1–2 users). Same gate whether or not Supabase cloud save is configured.
 * Credentials are in the bundle—treat as a light screen door, not a vault.
 *
 * "Remember me" stores a session flag in localStorage (survives browser restart).
 * Without it, the flag is only in sessionStorage (cleared when the tab/window session ends).
 */
const STORAGE_KEY = "flights-fdunleavy-session";

const EXPECTED_USER = "fd@fdunleavy.com";
const EXPECTED_PASS = "letsfly";

export function isAuthed(): boolean {
  return (
    localStorage.getItem(STORAGE_KEY) === "1" ||
    sessionStorage.getItem(STORAGE_KEY) === "1"
  );
}

/** @param persistent true = localStorage (remember me); false = this browser tab session only */
export function setAuthed(persistent: boolean): void {
  if (persistent) {
    localStorage.setItem(STORAGE_KEY, "1");
    sessionStorage.removeItem(STORAGE_KEY);
  } else {
    sessionStorage.setItem(STORAGE_KEY, "1");
    localStorage.removeItem(STORAGE_KEY);
  }
}

export function clearAuth(): void {
  sessionStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(STORAGE_KEY);
}

export function tryLogin(
  username: string,
  password: string,
  rememberMe: boolean
): boolean {
  const u = username.trim().toLowerCase();
  const p = password.trim();
  if (u === EXPECTED_USER.toLowerCase() && p === EXPECTED_PASS) {
    setAuthed(rememberMe);
    return true;
  }
  return false;
}
